import { DateTime } from 'luxon';

import { ReportSchedule } from '@/common/models';
import API from '@/org-app/api';
import {
  createApiAction,
  createAuditAction,
  createDeleteAction,
  createGetAllAction,
  createGetOneAction,
  createPostAction,
  createPutAction,
} from '@/utils/ActionsUtils';

import * as types from './mutation-types';

export default {
  createNewReportSchedule(
    { commit },
    reportSchedule = ReportSchedule.fromObject({
      id: -1,
      executionTimezone: DateTime.local().zone.name,
    }),
  ) {
    commit(types.CREATE_REPORTSCHEDULE, reportSchedule);
    return reportSchedule;
  },
  getReportSchedules: createGetAllAction(
    API.instance.getReportSchedules,
    types.UPDATE_REPORTSCHEDULES_LIST,
    'messages.failedToGetReportSchedules',
    true,
  ),
  getReportSchedule: createGetOneAction(
    API.instance.getReportSchedule,
    types.SAVE_REPORTSCHEDULES,
    'messages.failedToGetReportSchedule',
  ),
  createReportSchedules: createPostAction(
    API.instance.postReportSchedules,
    types.UPDATE_REPORTSCHEDULE,
    'messages.failedToCreateReportSchedule',
  ),
  updateReportSchedule: createPutAction(
    API.instance.putReportSchedule,
    types.SAVE_REPORTSCHEDULES,
    'messages.failedToUpdateReportSchedule',
  ),
  deleteReportSchedule: createDeleteAction(
    API.instance.deleteReportSchedule,
    types.DELETE_REPORTSCHEDULE,
    'messages.failedToDeleteReportSchedule',
  ),
  getReportScheduleAudit: createAuditAction(
    API.instance.getReportScheduleAudit,
    'messages.failedToGetReportScheduleAudit',
  ),
  getFutureReportExecutions: createApiAction(
    API.instance.getFutureReportExecutions,
    null,
    'messages.failedToGetFutureReportExecutions',
    false,
    (data) => data.map((x) => DateTime.fromISO(x)),
  ),
};
